import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';

class MetamaskHowTo extends Component {
    render() {
        return (
            <div>
              Metamask is a Chrome plug-in that will let you save your work on Zequencer to Ethereum.

              <div className="how-to-step">
                  1. First install the <a href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn'>Metamask</a> chrome plug-in.
              </div>
              <div className="how-to-step">
                2. Create a new account on your Metamask wallet, following the instructions <a href="https://blog.wetrust.io/how-to-install-and-use-metamask-7210720ca047">here</a>.
              </div>
              <div className="how-to-step">
                3. Click on the orange Metamask icon on the Chrome toolbar and switch the network from "Main Ethereum Network" to "Ropsten Test Network".
              </div>
              <div className="how-to-step">
                4. Get some free Ether for your new account by going <a href="https://faucet.metamask.io/">here</a>, and clicking "request 1 ether from faucet".
              </div>
            </div>
        );
    }
}

export default MetamaskHowTo;
 
